import AmexFAQs from './AmexFAQs';

export default AmexFAQs;
